import { ReturnClass,BaseeSearchClass } from 'projects/Shared-Lib/model/search-result';
import { SelectListItem } from '../lib/select/select-property';
import { UserProfileService } from '../services/user-profile.service';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import * as t from '../lib/select/select-service';
import { IHttpCallBack } from 'projects/Shared-Lib/services/data.service';


//search filter request api fields
export class SearchClass extends BaseeSearchClass {
  UserAccount?: string;
  UserName?: string;
  IsEnabled?: string;
}

export interface ADUser {
  EmployeeNumber: string,
  Mail: string,
  UserName: string
}

//structure of table for postback api
export class User {
  //[Key] - Guid
  UserId?: string;

  //[Required]
  //[StringLength(50, ErrorMessage = "The {0} must be at least {2} characters long.", MinimumLength = 2)]
  UserAccount?: string;

  //[DisplayFormat(ConvertEmptyStringToNull = false)]
  // [Required]
  // [StringLength(50, ErrorMessage = "The {0} must be at least {2} characters long.", MinimumLength = 2)]
  UserName?: string;

  // [Required]
  // [StringLength(50, ErrorMessage = "The {0} must be at least {2} characters long.", MinimumLength = 2)]
  EMail?: string;
  IsEnabled?: any;
  PagingSize?: string;

  IsDeleted?: boolean;
  CreatedDateTiime?: string;
  CreatedBy?: string;
  UpdatedDateTime?: string;
  UpdatedBy?: string;

  SelectEnabled?: string;

  constructor() {
    // this.UserId = '';
    // this.UserAccount = "";
    // this.UserName = "";
    // this.MailAddress = "";
    // this.EmpNo = "";
  }

  SetData(data : User) {
    this.UserId = data.UserId;
    this.UserAccount = data.UserAccount;
    this.UserName = data.UserName;
    this.EMail = data.EMail;
    this.PagingSize = data.PagingSize;
    this.IsEnabled = data.IsEnabled;
    this.SelectEnabled = data.IsEnabled ? 'Y' : 'N';
  }
}

// export interface ActionResult {
//   draw: number;
//   recordsTotal: number;
//   recordsFiltered: number;
//   data?: any;
// }

/** User Profile Search class */
export class UserProfile_Search {
  filter: SearchClass;
  ddlIsEnabled?: SelectListItem[];
  SelectedEnabled?: SelectListItem;
  DataResult?: ReturnClass;

  constructor() {
    this.filter = new SearchClass();
    this.filter.UserName = '';
    this.filter.UserAccount = '';
    this.filter.IsEnabled = '';

    this.ddlIsEnabled = t.GetItems(t.Items.Options_Enabled, true);
    this.DataResult = { draw: 1, recordsFiltered: 0, recordsTotal: 0, data: [] };
  }
}

/** document edit/create page models */
export class UserProfile_Document extends User {
  ddlPagingSize?: SelectListItem[];
  ddlIsEnabled?: SelectListItem[];
  CurrentUser: any;
  constructor(private DlgService: DialogService, private UserService: UserProfileService) {
    super();
    // this.ddlEnabled = t.GetItems(t.Items.Options_Enabled);
    this.CurrentUser = JSON.parse(localStorage.getItem('user'));
  }

  /** Get Document by UserId
   * @param uid : Guid
   */
  GetDocument(uid: string, finalCallback: IHttpCallBack = null) {
    this.UserService.GetUser(uid)
      .subscribe(ret => {
        if (ret.Success) {
          let doc = ret.Result as User;
          this.SetData(doc);

          this.initViewData(false, finalCallback);
        } else {
          this.DlgError(ret.Message);
        }
      });
  }

  initViewData(isNew, finalCallback: IHttpCallBack = null){

    this.UserService.GetInitData( (data) => {

        this.ddlPagingSize = [];
        this.ddlIsEnabled = [];

        data.PageSizeList.forEach((arrayItem, arrayIndex) => {
          let o : SelectListItem = {
            value : arrayItem.CDValue,
            text : arrayItem.CDName,
            index : arrayIndex + 1
          };
          this.ddlPagingSize.push(o);
        });
        this.PagingSize = isNew? this.ddlPagingSize[0].value.toString() : this.PagingSize;

        data.EnableList.forEach((arrayItem, arrayIndex) => {
          let o : SelectListItem = {
            value : arrayItem.CDValue,
            text : arrayItem.CDName,
            index : arrayIndex + 1
          };
          this.ddlIsEnabled.push(o);
        });
      }, null, finalCallback);

  }

  GetMyDocumemt(finalCallback: IHttpCallBack = null) {
    this.UserService.GetCurrentUser()
      .subscribe(ret => {
        if (ret.Success) {
          let doc = ret.Result as User;
          this.SetData(doc);
          this.initViewData(false, finalCallback);
        } else {
          this.DlgError(ret.Message);
        }
      });
  }
  GetADInfo(UserAccount: string) {
    //UserAccount is required !!
    let query = { userAccount: UserAccount };
    this.UserService.GetADUser(query)
      .subscribe(ret => {
        // console.log(ret);
        if (ret.Success) {
          this.UserAccount = ret.Result.UserPrincipalName;//.substring(0,ret.Data.UserPrincipalName.indexOf('@'));
          this.UserName = ret.Result.UserName;
          this.EMail = ret.Result.Mail;
        }
        else {
          this.DlgError(ret.Message);
          this.UserName = '';
          this.EMail = '';
        }
      });
  }
  /** Create New Document */
  Create() {
    this.IsEnabled = this.SelectEnabled === 'Y';
    let d = new User();
    d.SetData(this);
    return this.UserService.AddUser(d);
  }

  Save() {
    this.IsEnabled = this.SelectEnabled === 'Y';
    let d = new User();
    d.SetData(this);
    return this.UserService.UpdateUser(this.UserId, d);

  }

  DlgError(msg: string) {
    let result = this.DlgService.ErrorInformation(msg);
    result.then((ret) => {
    }).catch((error) => {
      console.error(error);
    });
  }

}
